console.log('✅ catalog-product.js loaded successfully!');

import { buildComponentMainSearchPageComponent } from '../../builders-components/main-search-page-component/main-search-page-component.js';

export async function buildComponentCatalogProduct(params, valuesInUrl) {
  // console.log(`🔄 Building Component: Specifiic Product -  params: ${params}  valuesInUrl: ${valuesInUrl}`);

  const layoutType = 'product';
  return await buildComponentMainSearchPageComponent(params, valuesInUrl, layoutType);
}

export async function buildComponentCatalogProductHeaderTags(params, valuesInUrl) {
  //import { fetchBlogCategoryByCategoryID, fetchGetAllFeaturedArticlesByBlogCategoryIDForBlogCategoryPage, fetchGetAllRecentArticlesByBlogCategoryIDForBlogCategoryPage } from "../../services/data-services/blog-data-service.js";
  // 1. Kick off *all* dynamic imports at once, including your component
  const [{ fetchGetCatalogProductSEOTagsByProductID }] = await Promise.all([
    import(
      /* webpackChunkName:"blog-data-service", webpackPrefetch: true */ '../../services/data-services/seo-data-service.js'
    ),
  ]);

  let result = '';

  let departmentID = '';
  let departmentSEOPageName = '';
  let categoryID = '';
  let categorySEOPageName = '';
  let productID = '';
  let productSEOPageName = '';

  // params like params: 17,clothes-shoes,1,womens-clothing,127,dresses

  //get the values from the params
  const valuesNeeded = params.split(',');
  departmentID = valuesNeeded[0];
  departmentSEOPageName = valuesNeeded[1];
  categoryID = valuesNeeded[2];
  categorySEOPageName = valuesNeeded[3];
  productID = valuesNeeded[4];
  productSEOPageName = valuesNeeded[5];

  ////get the values from the params
  ////const valuesNeeded = params?.split(",") || "";
  ////let selectedBlogCategoryID = valuesNeeded[1] || 0;
  ////let categorySEOPageName = valuesNeeded[2];

  //let paramsArray = params.split(",");
  //let selectedCategoryID = paramsArray[0];
  //let selectedSubcategoryID = paramsArray[2];

  ////convert selectedSubcategoryID to numnber
  //selectedCategoryID = convertStringToInt(selectedCategoryID);
  //selectedSubcategoryID = convertStringToInt(selectedSubcategoryID);

  // let selectedCategoryID = convertStringToInt(params);

  const currentPageSEOAPIResult = await fetchGetCatalogProductSEOTagsByProductID(productID);

  //alert("currentPageSEOAPIResult: " + JSON.stringify(currentPageSEOAPIResult));

  if (!currentPageSEOAPIResult) {
    console.log('❌ Error: seo catalog product not found');

    return result;
  }

  result = currentPageSEOAPIResult;

  return result;
}
